import { render, staticRenderFns } from "./ZiXunTuiJian.vue?vue&type=template&id=9692ad5e&scoped=true&"
import script from "./ZiXunTuiJian.vue?vue&type=script&lang=js&"
export * from "./ZiXunTuiJian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9692ad5e",
  null
  
)

export default component.exports